import { writable } from 'svelte/store'

export const clientStore = writable()
export const mileageStore = writable()
export const transactionStore = writable();
export const scanStore = writable();
export const dataStore = writable();
export const noteStore = writable();
export const timeStore = writable();
